

import * as actionTypes from '../actions';

const initialState = {
    app_users:              [],
    app_users_this_week:    [],
    app_admins:             [],
    app_developers:         [],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
      
        case actionTypes.SET_APP_USERS:

            return {
                ...state,
                app_users: action.payload.objects
            }

        case actionTypes.SET_APP_USERS_THIS_WEEK:

                return {
                    ...state,
                    app_users_this_week: action.payload.objects
                }

        case actionTypes.SET_APP_ADMINS:

            return {
                ...state,
                app_admins: action.payload.objects
            }

        case actionTypes.SET_APP_DEVELOPERS:

            return {
                ...state,
                app_developers: action.payload.objects
            }

        default:
        
            return state;

    }
}

export default reducer;